import Constants from '../Constants.js';
import ModuleReducer from './ModuleReducer.js';
const {
  getStatus,
  getError,
  getModules
} = ModuleReducer;
class Module {
  constructor(projectId, name) {
    this.projectId = projectId;
    this.name = name;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: Constants.MODULE_STATUS,
        name: this.name,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: Constants.MODULE_STATUS,
          projectId,
          name: this.name,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  get(opts) {
    return this.createAction('load', 'loading', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).module(this.name).get(opts);
      dispatch({
        type: Constants.MODULE_UPDATE,
        projectId,
        module: r
      });
      return r;
    });
  }
  update(data) {
    return this.createAction('update', 'updating', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).module(this.name).update(data);
      dispatch({
        type: Constants.MODULE_UPDATE,
        projectId,
        module: r
      });
      return r;
    });
  }
  delete() {
    return this.createAction('delete', 'deleting', async (dispatch, getState, {
      api
    }, projectId) => {
      const r = await api.project(projectId).module(this.name).delete();
      dispatch({
        type: Constants.MODULE_REMOVE,
        projectId,
        moduleName: this.name
      });
      return r;
    });
  }

  // State accessors 
  getStatus(state) {
    return getStatus(state, this.projectId);
  }
  getError(state) {
    return getError(state, this.projectId);
  }
  getModules(state) {
    return getModules(state, this.projectId);
  }
}
export default Module;